import PropTypes from 'prop-types';

export const descriptorShape = {
    id: PropTypes.string.isRequired,
    descriptor: PropTypes.shape({
        id: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired,
        dataType: PropTypes.string.isRequired,
        displayOrder: PropTypes.number.isRequired,
        isRequiredForDocumentType: PropTypes.bool.isRequired,
        isActiveForDocumentType: PropTypes.bool.isRequired,
        dataSourceId: PropTypes.string,
        dataset: PropTypes.shape({
            id: PropTypes.string.isRequired,
            dataType: PropTypes.string.isRequired,
            values: PropTypes.arrayOf(PropTypes.any).isRequired
        })
    }),
    values: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any,
        originalValue: PropTypes.any
    })),
    touched: PropTypes.bool.isRequired,
    editorValue: PropTypes.any.isRequired,
    invalidValue: PropTypes.bool.isRequired,
    highlightedIndex: PropTypes.number.isRequired,
    order: PropTypes.number.isRequired
};

export default PropTypes.shape(descriptorShape);
